import { TranslatedText } from '../Translation';

export interface Blog {
  id: number;
  title: string;
  titleTranslation: TranslatedText;
  slug: string;
  shortDescription: string;
  shortDescriptionTranslation: TranslatedText;
  description: string;
  descriptionTranslation: TranslatedText;
  locale?: string;
  coverImage: string;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyBlog = (): Blog => ({
  id: 0,
  title: '',
  titleTranslation: {},
  slug: '',
  shortDescription: '',
  shortDescriptionTranslation: {},
  description: '',
  descriptionTranslation: {},
  coverImage: '',
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const blogFromResponse = (responseData: any): Blog => ({
  id: responseData.id,
  title: responseData.title,
  titleTranslation: responseData.title_translation ?? {},
  slug: responseData.slug,
  shortDescription: responseData.short_description,
  shortDescriptionTranslation: responseData.short_description_translation ?? {},
  description: responseData.description,
  descriptionTranslation: responseData.description_translation ?? {},
  locale: responseData.locale,
  coverImage: responseData.cover_image,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const blogToUpsertRequest = (blog: Blog) => ({
  title: blog.title,
  title_translation: blog.titleTranslation,
  short_description: blog.shortDescription,
  short_description_translation: blog.shortDescriptionTranslation,
  description: blog.description,
  description_translation: blog.descriptionTranslation,
  locale: blog.locale,
});
